import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { CTAButton, usePageMeta } from "../components/kit";

const STRINGS = {
  en: {
    meta: "Confirm subscription — KairosHK",
    eyebrow: "Insights",
    confirming: "Confirming…",
    title: "You are subscribed.",
    msg: "Subscription confirmed. New writing lands roughly twice a month.",
    read: "Read the latest",
    errTitle: "That link did not work.",
    back: "Back to Insights",
    missing: "Missing confirmation token.",
  },
  el: {
    meta: "Επιβεβαίωση εγγραφής — KairosHK",
    eyebrow: "Αναλύσεις",
    confirming: "Επιβεβαίωση…",
    title: "Η εγγραφή σας ολοκληρώθηκε.",
    msg: "Η εγγραφή επιβεβαιώθηκε. Νέα αρθρογραφία περίπου δύο φορές τον μήνα.",
    read: "Διαβάστε τα πρόσφατα",
    errTitle: "Ο σύνδεσμος δεν λειτούργησε.",
    back: "Επιστροφή στις Αναλύσεις",
    missing: "Λείπει το token επιβεβαίωσης.",
  },
};

export default function SubscribeConfirm() {
  const [params] = useSearchParams();
  const T = STRINGS[params.get("lang") === "el" ? "el" : "en"];
  usePageMeta(T.meta, T.msg);
  const [state, setState] = useState({ status: "loading", msg: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ status: "error", msg: T.missing }); return; }
    api.post("/subscribe/confirm", { token })
      .then(() => setState({ status: "done", msg: T.msg }))
      .catch((err) => setState({ status: "error", msg: formatApiErrorDetail(err.response?.data?.detail) }));
  }, [params, T]);

  return (
    <div className="k-section k-container" data-testid="subscribe-confirm-page">
      <p className="eyebrow mb-6">{T.eyebrow}</p>
      {state.status === "loading" && <h1 className="k-h2">{T.confirming}</h1>}
      {state.status === "done" && (
        <>
          <h1 className="k-h2 mb-6" data-testid="subscribe-confirmed-title">{T.title}</h1>
          <p className="text-ink-muted max-w-xl mb-10">{state.msg}</p>
          <CTAButton to="/insights" testId="confirm-read-insights-btn">{T.read}</CTAButton>
        </>
      )}
      {state.status === "error" && (
        <>
          <h1 className="k-h2 mb-6">{T.errTitle}</h1>
          <p className="text-ink-muted max-w-xl mb-10" data-testid="subscribe-confirm-error">{state.msg}</p>
          <CTAButton to="/insights" variant="secondary" testId="confirm-back-btn">{T.back}</CTAButton>
        </>
      )}
    </div>
  );
}
